export function ErrorPage(){
    return <div className="vw vw-error-page">
        <h3>Error!</h3>
        <p>Something went wrong...</p>
    </div>
}